export const hydrateColorState = (color = '#000000') => () => {
  let hexString = color.trim().toUpperCase();
  if (hexString.slice(0, 1) === '#') {
    hexString = hexString.slice(1);
  }
  if (!/^([a-fA-F0-9]{3}|[a-fA-F0-9]{6})$/.test(hexString)) {
    hexString = '000000';
  }
  if (hexString.length === 3) {
    hexString = hexString[0] + hexString[0] + hexString[1] + hexString[1] + hexString[2] + hexString[2];
  }
  hexString = `#${hexString}`;
  const {
    red,
    green,
    blue
  } = convertHexToRGB(hexString);
  const {
    hue,
    saturation,
    value
  } = convertRGBToHSV(red, green, blue);
  return {
    r: red,
    g: green,
    b: blue,
    h: hue,
    s: saturation,
    v: value,
    hex: hexString
  };
};
export const convertHSVToRGB = (hue, saturation, value) => {
  const hueValue = hue % 360 / 60;
  const satValue = saturation / 100;
  const valValue = value / 100;
  const iC = valValue * satValue;
  const iX = iC * (1 - Math.abs(hueValue % 2 - 1));
  const iM = valValue - iC;
  let red = 0;
  let green = 0;
  let blue = 0;
  const i = Math.floor(hueValue);
  switch (i) {
    case 0:
      red = iC;
      green = iX;
      break;
    case 1:
      red = iX;
      green = iC;
      break;
    case 2:
      green = iC;
      blue = iX;
      break;
    case 3:
      green = iX;
      blue = iC;
      break;
    case 4:
      red = iX;
      blue = iC;
      break;
    case 5:
      red = iC;
      blue = iX;
      break;
    default:
      red = 0;
      blue = 0;
      green = 0;
      break;
  }
  red = Math.floor((red + iM) * 255);
  green = Math.floor((green + iM) * 255);
  blue = Math.floor((blue + iM) * 255);
  return {
    red,
    green,
    blue
  };
};
export const convertRGBToHex = (red, green, blue) => {
  const redHex = red.toString(16);
  const greenHex = green.toString(16);
  const blueHex = blue.toString(16);
  const hex = `#${[redHex, greenHex, blueHex].map(val => val.length === 1 ? val = `0${val}` : val).join('').toUpperCase()}`;
  return hex;
};
export const convertHexToRGB = hexValue => {
  let hex = hexValue;
  if (hex.slice(0, 1) === '#') {
    hex = hex.slice(1);
  }
  if (hex.length === 3) {
    hex = hex[0] + hex[0] + hex[1] + hex[1] + hex[2] + hex[2];
  }
  const red = parseInt(hex.slice(0, 2), 16);
  const green = parseInt(hex.slice(2, 4), 16);
  const blue = parseInt(hex.slice(4, 6), 16);
  return {
    red,
    green,
    blue
  };
};
export const convertRGBToHSV = (red, green, blue) => {
  const max = Math.max(red, green, blue);
  const min = Math.min(red, green, blue);
  const delta = max - min;
  let hueValue = 0;
  let satValue = max === 0 ? 0 : 100 * delta / max;
  const valValue = Math.round(max * 100 / 255);
  if (satValue === 0) {
    hueValue = 0;
  } else if (red === max) {
    hueValue = 60.0 * ((green - blue) / delta % 6);
  } else if (green === max) {
    hueValue = 120.0 + 60.0 * (blue - red) / delta;
  } else if (blue === max) {
    hueValue = 240.0 + 60.0 * (red - green) / delta;
  }
  if (hueValue < 0.0) {
    hueValue += 359.9;
  }
  hueValue = Math.round(hueValue);
  satValue = Math.round(satValue);
  return {
    hue: hueValue,
    saturation: satValue,
    value: valValue
  };
};
export const isValidHex = hexString => /^#([a-fA-F0-9]{3}|[a-fA-F0-9]{6})$/.test(hexString);

// For MulticolorSwatch
export const getColorsForMultiSwatch = colors => {
  const automaticColor = colors.slice(0, 4);
  if (automaticColor.length >= 4) {
    automaticColor.slice(4, automaticColor.length);
  } else {
    for (let i = 0; i < 4; i++) {
      automaticColor.push(automaticColor[i]);
      if (automaticColor.length === 4) break;
    }
  }
  return automaticColor;
};
export const hexToRGBString = hexString => {
  const {
    red,
    green,
    blue
  } = convertHexToRGB(hexString);
  return `rgb(${red},${green},${blue})`;
};
const isThreeDigitHex = value => {
  return /^#[0-9a-fA-F]{3}$/.test(value);
};
export const convertToSixDigitHex = value => {
  if (isThreeDigitHex(value)) {
    return value.replace(/^#([0-9a-fA-F])([0-9a-fA-F])([0-9a-fA-F])$/, '#$1$1$2$2$3$3').toUpperCase();
  }
  return value.toUpperCase();
};
export const remToPX = rem => {
  return rem * parseFloat(getComputedStyle(document.documentElement).fontSize || '16px');
};
//# sourceMappingURL=ColorPickerUtil.js.map